export const RISK_STATISTICS_ENDPOINT = '/tax/v1/risk/rule/data/countRiskData';
export const RISK_REFRESH_ENDPOINT = '/tax/v1/risk/rule/data/refreshData';

function numberText(value) {
  return value == null ? '暂无' : `${value}`;
}

function moneyText(value) {
  if (value == null || value === '') return '暂无';
  const amount = Number(value);
  if (Number.isNaN(amount)) return `${value}`;
  return `¥${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fetchRiskStatistics(request) {
  return request.get(RISK_STATISTICS_ENDPOINT).then((res) => (
    res && res.success ? (res.result || {}) : {}
  ));
}

export function refreshRiskData(request) {
  return request.get(RISK_REFRESH_ENDPOINT);
}

export function formatRiskStatistics(data = {}) {
  const blockCount = numberText(data.riskBlockNum);
  const blockAmount = moneyText(data.riskBlockAmount);
  return {
    signUserNum: numberText(data.signUserNum),
    alarmUserNum: numberText(data.alarmUserNum),
    alarmBindAccountNum: numberText(data.alarmBindAccountNum),
    alarmUserCashAmount: moneyText(data.alarmUserCashAmount),
    riskBlockText: `${blockCount} 笔 / ${blockAmount}`,
    lastRefreshTime: data.lastRefreshTime || '刷新中...',
  };
}
